import '@popperjs/core'
import 'bootstrap/js/src/collapse'
import Dropdown from 'bootstrap/js/src/dropdown'

(() => {
  'use strict'

  const body = document.querySelector('body')
  const scrollCheck = () => {
    const scrollPos = document.documentElement.scrollTop
    const threshold = 0
    const isScrolled = scrollPos > threshold

    body.classList.toggle('scrolled', isScrolled)
  }

  for (const type of ['load', 'scroll', 'resize']) {
    window.addEventListener(type, scrollCheck)
  }

  for (const elem of document.querySelectorAll('.burger')) {
    elem.addEventListener('click', () => {
      const isOpen = elem.getAttribute('aria-expanded') === 'true'
      body.classList.toggle('nav-open', isOpen)
    })
  }

  // Handle sharing links
  for (const elem of document.querySelectorAll('.share-link')) {
    const href = elem.attributes.href.value.replaceAll('URL', encodeURI(window.location.href))
    elem.setAttribute('href', href)

    if (elem.hasAttribute('target')) {
      elem.addEventListener('click', e => {
        e.preventDefault()
        const url = elem.getAttribute('href')
        window.open(url, elem.attributes.target.value, 'width=600,height=800')
      })
    }
  }

  for (const elem of document.querySelectorAll('.share-link')) {
    elem.addEventListener('click', e => {
      e.preventDefault()
      const url = elem.getAttribute('href')
      window.open(url, '_blank', 'width=600,height=800')
    })
  }

  const requiredFields = document.querySelectorAll('input[required], select[required], textarea[required]')
  for (const el of requiredFields) {
    const label = el.parentElement.querySelector('label')
    label.classList.add('required')
  }

  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  const forms = document.querySelectorAll('.needs-validation')

  // Loop over them and prevent submission
  for (const form of Array.from(forms)) {
    form.addEventListener('submit', event => {
      if (!form.checkValidity()) {
        event.preventDefault()
        event.stopPropagation()
      }

      form.classList.add('was-validated')
    }, false)
  }

  for (const elem of document.querySelectorAll('.more-link')) {
    elem.addEventListener('click', e => {
      e.preventDefault()

      for (const cont of elem.parentNode.querySelectorAll('div')) {
        cont.classList.toggle('d-none')
      }

      elem.classList.toggle('icon-caret_up')
      elem.classList.toggle('icon-caret_down')
      for (const txt of elem.querySelectorAll('span')) {
        txt.classList.toggle('d-none')
      }
    })
  }

  for (const elem of document.querySelectorAll('.settings-toggle')) {
    const menuContainer = elem.nextElementSibling

    const toggleSettings = (expanded = null) => {
      if (expanded === null) {
        expanded = elem.getAttribute('aria-expanded') === 'false'
      }

      elem.setAttribute('aria-expanded', (expanded ? 'true' : 'false'))
      menuContainer.classList.toggle('active', expanded)
    }

    elem.addEventListener('click', e => {
      e.preventDefault()

      toggleSettings()
    })

    document.body.addEventListener('click', event => {
      // Abort if no event was found
      if (!event) {
        return
      }

      if (!menuContainer.contains(event.target) && !elem.contains(event.target)) {
        // click outside, close the menu
        toggleSettings(false)
      }
    })
  }

  for (const elem of document.querySelectorAll('.search-container .btn-toggler')) {
    elem.addEventListener('click', e => {
      e.preventDefault()

      const willExpand = (elem.getAttribute('aria-expanded') === 'false')
      const newLabel = elem.dataset[`label${willExpand ? 'Expanded' : 'Collapsed'}`]
      const labelElem = elem.querySelector('.toggle-label')
      const cardContainer = elem.nextElementSibling
      cardContainer.classList.toggle('d-none')
      elem.setAttribute('aria-expanded', willExpand ? 'true' : 'false')
      labelElem.textContent = newLabel
    })
  }

  for (const elem of document.querySelectorAll('[data-accordion-id]')) {
    elem.addEventListener('click', e => {
      e.preventDefault()

      const id = elem.getAttribute('data-accordion-id')
      const state = elem.getAttribute('data-accordion-state')
      const accordion = document.getElementById(id)
      const buttons = accordion.querySelectorAll(`.accordion-button${(state === 'collapsed' ? '.collapsed' : '')}`)

      for (const but of buttons) {
        but.click()
      }

      if (state === 'collapsed') {
        elem.removeAttribute('data-accordion-state')
      } else {
        elem.setAttribute('data-accordion-state', 'collapsed')
      }
    })
  }

  for (const elem of document.querySelectorAll('.navbar-collapse')) {
    elem.addEventListener('show.bs.collapse', () => {
      const activeToggle = elem.querySelectorAll('.dropdown-toggle.active')

      for (const el of activeToggle) {
        el.classList.add('show')
        el.setAttribute('aria-expanded', 'true')

        const submenuContainer = el.nextElementSibling
        const dropdown = Dropdown.getOrCreateInstance(submenuContainer)
        dropdown.show()
      }
    })
  }

  for (const elem of document.querySelectorAll('.auto-submit')) {
    elem.addEventListener('change', () => {
      elem.form.submit()
    })
  }
})()
